import { take, call, put} from 'redux-saga/effects';
import {
	fetchConsigneeListNew,
	failFetchConsigneeListNew,
	setConsigneeListDataNew,
	updateConsigneeFlagNew,
	failUpdateConsigneeFlagNew,
	successUpdateConsigneeFlagNew,
	getPdfItemsConsigneeNew,
	failGetPdfItemsConsigneeNew,
	setPdfItemsConsigneeNew,
	undoConsigneeFlagNew,
	failUndoConsigneeFlagNew,
	successUndoConsigneeFlagNew,
	fetchDecodeProcessManualCount,
	failFetchDecodeProcessManualCount,
	setDecodeProcessManualCount,
	getPdfItemsConsigneeMod,
	failGetPdfItemsConsigneeMod,
	setPdfItemsConsigneeMod,
	fetchCsvDataConsigneeListNew,
	failFetchCsvDataConsigneeListNew,
	setCsvDataConsigneeListNew,
} from '../actions';
import superFetch from '../modules/superFetch';
import {getApiUrl} from "./index";

export function* handleFetchConsigneeListNew() {
	while (true) {
		const action = yield take(`${fetchConsigneeListNew}`);
		const { payload, err } = yield call(superFetch, {
			url: getApiUrl() + 'consignee-list/',
			type: 'POST',
			data: action.payload
		});
		if (err || payload.state === 'NG') {
			const msg = (err) ? String(err).split('Error: ')[1] : payload.message;
			yield put(failFetchConsigneeListNew({err:msg}));
			continue;
		}
		yield put(setConsigneeListDataNew(Object.assign({}, payload, {})));
	}
}

export function* handleGetPdfConsigneeNew() {
	while (true) {
		const action = yield take(`${getPdfItemsConsigneeNew}`);
		const { payload, err } = yield call(superFetch, {
			url: getApiUrl() + 'get-pdf-consignee/',
			type: 'POST',
			data: action.payload
		});
		if (err || payload.state === 'NG') {
			const msg = (err) ? String(err).split('Error: ')[1] : payload.message;
			yield put(failGetPdfItemsConsigneeNew({err:msg}));
			continue;
		}
		yield put(setPdfItemsConsigneeNew(Object.assign({}, payload, {})));
	}
}


export function* handleUpdateConsigneeFlagNew() {
	while (true) {
		const action = yield take(`${updateConsigneeFlagNew}`);
		const { payload, err } = yield call(superFetch, {
			url: getApiUrl() + 'update-consignee-flag/',
			type: 'POST',
			data: action.payload
		});
		if (err || payload.state === 'NG') {
			const msg = (err) ? String(err).split('Error: ')[1] : payload.message;
			yield put(failUpdateConsigneeFlagNew({err:msg}));
			continue;
		}
		yield put(successUpdateConsigneeFlagNew(Object.assign({}, payload, {})));
	}
}

export function* handleUndoConsigneeFlagNew() {
	while (true) {
		const action = yield take(`${undoConsigneeFlagNew}`);
		const { payload, err } = yield call(superFetch, {
			url: getApiUrl() + 'undo-consignee-flag/',
			type: 'POST',
			data: action.payload
		});
		if (err || payload.state === 'NG') {
			const msg = (err) ? String(err).split('Error: ')[1] : payload.message;
			yield put(failUndoConsigneeFlagNew({err:msg}));
			continue;
		}
		yield put(successUndoConsigneeFlagNew(Object.assign({}, payload, {})));
	}
}

export function* handleFetchDecodeProcessManualCount() {
	while (true) {
		const action = yield take(`${fetchDecodeProcessManualCount}`);
		const { payload, err } = yield call(superFetch, {
			url: getApiUrl() + 'decode-process-manual-count/',
			type: 'POST',
			data: action.payload
		});
		if (err || payload.state === 'NG') {
			const msg = (err) ? String(err).split('Error: ')[1] : payload.message;
			yield put(failFetchDecodeProcessManualCount({err:msg}));
			continue;
		}
		yield put(setDecodeProcessManualCount(Object.assign({}, payload, {})));
	}
}


export function* handleGetPdfConsigneeMod() {
	while (true) {
		const action = yield take(`${getPdfItemsConsigneeMod}`);
		const { payload, err } = yield call(superFetch, {
			url: getApiUrl() + 'get-pdf-consignee-mod/',
			type: 'POST',
			data: action.payload
		});
		if (err || payload.state === 'NG') {
			const msg = (err) ? String(err).split('Error: ')[1] : payload.message;
			yield put(failGetPdfItemsConsigneeMod({err:msg}));
			continue;
		}
		yield put(setPdfItemsConsigneeMod(Object.assign({}, payload, {})));
	}
}


export function* handleFetchCsvDataFromConsigneeListNew() {
	while (true) {
		const action = yield take(`${fetchCsvDataConsigneeListNew}`);
		const { payload, err } = yield call(superFetch, {
			url: getApiUrl() + 'get-csv-consignee/',
			type: 'POST',
			data: action.payload
		});
		if (err || payload.state === 'NG') {
			const msg = (err) ? String(err).split('Error: ')[1] : payload.message;
			yield put(failFetchCsvDataConsigneeListNew({err:msg}));
			continue;
		}
		yield put(setCsvDataConsigneeListNew(Object.assign({}, payload, {})));
	}
}



// WEBPACK FOOTER //
// ./src/sagas/consignee-list-new.js